// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 768 ? "App" : chunkId) + "." + {"302":"3d293c25","768":"aac970a6"}[chunkId] + ".chunk.js";
};